import routes from '@/config/routes';
import { v3Get, v3Post, v3Remove } from '@/api/axios.instance.V3';
import type { ApiResponse } from '../types';
import { IVoiceQuestionPayload, IVoiceQuestionSavePayload } from '@/store/admin/types/types';

const getVoiceQuestionsList = (gigId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.voiceQuestions.voiceQuestionList}/${gigId}`);

const getVoiceQuestionCategoriesList = (): ApiResponse => v3Get(`${routes.backendUrl.voiceQuestions.categoriesList}`);

const arrangeVoiceQuestionOrder = (payload: IVoiceQuestionPayload): ApiResponse =>
  v3Post(routes.backendUrl.voiceQuestions.arrangeVoiceQuestionOrder, payload);

const assignedVoiceQuestionOrder = (payload: IVoiceQuestionPayload): ApiResponse =>
  v3Post(routes.backendUrl.voiceQuestions.assignedVoiceQuestionOrder, payload);

const getAllVoiceQuestionsList = (gigId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.voiceQuestions.allVoiceQuestionList}/${gigId}`);

const deleteClientVoiceQuestionsList = (gigId: number): ApiResponse =>
  v3Remove(`${routes.backendUrl.voiceQuestions.removeVoiceQuestionList}/${gigId}`);

const saveVoiceQuestion = (payload: IVoiceQuestionSavePayload): ApiResponse =>
  v3Post(routes.backendUrl.voiceQuestions.saveVoiceQuestion, payload);

export const voiceQuestionApi = {
  getVoiceQuestionsList,
  getAllVoiceQuestionsList,
  getVoiceQuestionCategoriesList,
  arrangeVoiceQuestionOrder,
  deleteClientVoiceQuestionsList,
  assignedVoiceQuestionOrder,
  saveVoiceQuestion,
};
